<template>
  <section class="page-title-wrap d-flex position-relative text-center over-bg" :class="{ active: active }">
    <svg
      class="overflow-hidden"
      xmlns="http://www.w3.org/2000/svg"
      :viewBox="'0 0 ' + winWFix + ' ' + wrapH"
      :style="wrapStyles"
    >
      <defs>
        <linearGradient id="page6-a" x1="117.204%" x2="-10.173%" y1="144.13%" y2="-10.803%">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="darkMain"/>
        </linearGradient>
        <linearGradient id="page6-b" x1="124.495%" x2="12.266%" y1="123.126%" y2="11.08%">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="darkMain"/>
        </linearGradient>
      </defs>
      <rect :width="winW + 2" x="-1" :height="wrapH" fill="url(#page6-a)"/>
      <rect
        :width="rectDims[0]"
        :height="rectDims[1]"
        :x="((winW / 2) - 187.5) + (375 - rectDims[0]) / 2"
        y="95"
        fill="url(#page6-b)"
        rx="14"
        style="opacity: 0"
        ref="phone"
      />
    </svg>

    <div class="position-absolute d-flex flex-column align-items-stretch w-75 title-text"
         :style="txtStyles">
      <header class="d-flex flex-column justify-content-end align-items-center pb-5 header-wrap">
        <h1
          class="mb-0 heading"
          v-html="head"
          ref="head"
          :style="{ letterSpacing: headSpace + 'em', paddingLeft: headSpace + 'em' }"
        ></h1>
        <span class="subhead" v-html="subhead" ref="sub"></span>
      </header>

      <div class="footer-wrap d-flex flex-column justify-content-center align-items-center">
        <h2
          class="mb-4 keyword"
          v-html="kw"
          ref="kw"
          :style="{ letterSpacing: kwSpace + 'em', paddingLeft: kwSpace + 'em' }"
        ></h2>

        <div class="numeral-wrap position-relative">
          <ring-vect ref="ring"/>

          <div class="dashes d-flex justify-content-center overflow-hidden position-absolute">
            <div class="inner position-absolute h-100" :style="{ borderLeft: '1px dashed ' + mainColor }"></div>
          </div>
          <span
            class="adobe-clean-serif-med numeral position-absolute absolute-center"
            ref="num"
            v-html="numeral"
          ></span>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import { TimelineMax } from 'gsap'
  import { darken, shuffleArr } from '@/lib/funcs'
  import TitleMixin from '@/components/report/mixins/TitleMixin'

  export default {
    name: 'Title6',
    mixins: [ TitleMixin ],
    data () { return { tl: new TimelineMax() } },
    computed: {
      darkMain () { return darken( this.mainColor, 1 - (64 / 255) ) },

      rectDims () { return this.isSmall ? [ 240, 516 ] : [ 325, 699 ] }
    },
    methods: {
      setTweens () {
        this.tl.set( [ this.headSpans, this.kwSpans, this.$refs.sub, this.$refs.ring.$el, this.$refs.num ], { opacity: 0 } )
          .set( this.$refs.ring.$el, { scale: 0 } )
          .set( this.$refs.sub, { yPercent: 100 } )
          .set( this.$refs.phone, { opacity: 0, yPercent: 10 } )
      },
      tweenIn () {
        let headSpans = shuffleArr( [ ...this.headSpans ] )
        let kwSpans = shuffleArr( [ ...this.kwSpans ] )

        this.tl.to( this, this.time, { headSpace: 0.1 }, 'in' )
          .staggerTo( headSpans, this.time, { opacity: 1 }, this.stagger, 'in' )
          .to( [ this.$refs.sub, this.$refs.phone ], this.time, { opacity: 1, yPercent: 0 }, 'in' )
          .to( this, this.time, { kwSpace: 0.2666 }, 'in+=' + (this.stagger * 2) )
          .staggerTo( kwSpans, this.time, { opacity: 1 }, this.stagger, 'in+=' + (this.stagger * 2) )
          .to( this.$refs.ring.$el, this.time, { opacity: 1, scale: 1 }, 'in+=' + (this.stagger * 2) )
          .to( this.$refs.num, this.time / 2, { opacity: 1 }, 'in+=' + (this.stagger * 2 + (this.time / 2)) )
          .call( () => this.$emit( 'tween-done' ) )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/report/titleVects/Title6.vue